//All the constants used throughout the app declared here

export const APP_NAME = 'Sampark';
export const APP_URL = 'https://sampark-video-calls.netlify.app';
export const BACKEND_URL = 'https://sampark-video.herokuapp.com/';
// export const BACKEND_URL='http://localhost:5000';
